import { createGlobalState } from 'react-hooks-global-state';
import { BrokerRegion } from '@ace-clublabs/payment-types';
import { AppFlow, IAutoPayEligibility, MembershipLevel } from '@lib/types';
import { Error } from './types';

type State = {
  error?: Error;
  amountDue: number;
  membershipNumber: string;
  zipCode: string;
  membershipLevel: MembershipLevel | '';
  clubCode: string;
  autoPay?: IAutoPayEligibility;
  autoPayEnrolled: boolean;
  optedDiscount: boolean;
  emailOnFile?: string;
  campaignCode?: string;
  isMobileApp: boolean;
  queryProps: any;
  taxAmount: number;
  productCost: number;
  preDiscountAmountDue: number;
  appFlow: AppFlow | '';
  brokerRegion?: BrokerRegion;
  membershipProductRV: string;
  billPlan: string;
  customerId?: string;
};

const initialState = {
  error: undefined,
  amountDue: 0,
  membershipNumber: '',
  membershipLevel: '',
  zipCode: '',
  clubCode: '',
  autoPay: undefined,
  autoPayEnrolled: false,
  optedDiscount: false,
  emailOnFile: undefined,
  campaignCode: '',
  isMobileApp: false,
  queryProps: {},
  taxAmount: 0,
  productCost: 0,
  preDiscountAmountDue: 0,
  appFlow: '',
  brokerRegion: undefined,
  membershipProductRV: '',
  billPlan: '',
  customerId: undefined,
};

export const createInitialState = (): State => {
  const sessionStateString = sessionStorage.getItem('membershipPwolState') || '{}';
  const sessionState = JSON.parse(sessionStateString);
  const state = { ...initialState, ...sessionState };
  return state;
};

export const { useGlobalState, setGlobalState } = createGlobalState<State>(createInitialState());
